import classNames from 'classnames';
import { useFormikContext } from 'formik';
import { Button, Flex, useIsMobile } from 'yoso';
import { breakpoints } from '~/components/Breakpoint/Breakpoint.hook';
import { Icon } from '~/components/Icon';
import { Level } from '~/components/Level';
import { LevelUpValues } from '~/components/LevelUp/LevelUp';
import './LevelUpFormHeroButton.scss';

export interface LevelUpFormHeroButtonProps {
  className?: string;
}

export const LevelUpFormHeroButton = ({ className }: LevelUpFormHeroButtonProps) => {
  const {
    values: { level: from },
    isValid,
    isSubmitting,
    submitForm,
  } = useFormikContext<LevelUpValues>();
  const to = from + 1;
  const isMobile = useIsMobile(undefined, breakpoints.medium);
  const levelType = isMobile ? 'long' : 'short';

  return (
    <Button
      type="button"
      color="secondary"
      onClick={submitForm}
      className={classNames('level-up-hero-button', className)}
      disabled={!isValid || isSubmitting}
      data-event="click"
      data-event-target="levelup_btn">
      <Flex container alignItems="center">
        <Flex flex={1}>
          <Level level={from} type={levelType} hasName />
        </Flex>
        <Icon
          className="arrow-icon"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18 11.7029L11.2971 18.4057L9.56151 16.6701L13.3015 12.9301H4.95623V10.4756H13.3015L9.56151 6.73563L11.2971 5L18 11.7029Z"
            fill="currentColor"
          />
        </Icon>
        <Flex flex={1}>
          <Level level={to} type={levelType} hasName />
        </Flex>
      </Flex>
    </Button>
  );
};
